import * as R from 'ramda';
import ReactSVG from 'react-svg';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import { SearchBar } from 'antd-mobile';
import { isWeixinMobile } from 'utils/util';
import { inject, observer } from 'mobx-react';
// @ts-ignore
import Masonry from 'react-responsive-masonry';
import ListWrapper from 'components/Common/ListWrapper';
import { getToMiniProgramDownloadUrl } from 'utils/mini_program';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { PlatformAuthClickActionWrap } from 'components/PlatformAuthClickActionWrap';

import { VePlayer } from './VePlayer';
import { MultiVideoProps } from './index';
import { useV2Video } from './use-v2-videos';
import { VerticalSwiper } from './vertical-swipper';

import '../BigPic/BigPic.scss';
import './video-list-wrap.scss';

// import useTheme from 'components/hooks/useTheme';

export const isFunction = (fn: any) => typeof fn === 'function';

const DetectWindowWidth = (props: any) => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <div ref={ref} className="detect-window-width">
      {isFunction(props.children)
        ? props.children({ width: ref.current?.offsetWidth })
        : props.children}
    </div>
  );
};

export const BothCenter = (props: any) => {
  const { children } = props;
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  );
};

/**
 * 获取真实的url
 * url: //xx.xx.xx.xx/xx.mp4?xx=xx
 * return: https://xx.xx.xx.xx/xx.mp4?xx=xx
 *
 * url: http://xx.xx.xx.xx/xx.mp4?xx=xx
 * return: https://xx.xx.xx.xx/xx.mp4?xx=xx
 *
 * @param url
 */
export const getRealUrl = (url: string) => {
  if (url.startsWith('//')) {
    return `https:${url}`;
  }
  if (url.startsWith('http:')) {
    return url.replace('http:', 'https:');
  }
  return url;
};

/**
 * 通过url获取文件名
 * url: //xx.xx.xx.xx/xx.mp4?xx=xx => xx.mp4
 * @param url
 */
export const getNameByUrl = (url: string) => {
  const arr = url.split('/');
  const nameWithQuery = arr[arr.length - 1];
  return nameWithQuery.split('?')[0];
};

export const getFileNameByArbitraryUrl = (url: string) => {
  const realUrl = getRealUrl(url);
  return getNameByUrl(realUrl);
};

export const humanizeDuration = (duration: number) => {
  const min = Math.floor(duration / 60);
  const sec = Math.ceil(duration % 60);
  const minStr = min < 10 ? '0' + min : min;
  return `${minStr}:${sec < 10 ? '0' + sec : sec}`;
};

export const getDownloadVideoLink = (url: string) => {
  const list = [{ id: 1, url }];
  const downloadLink = getToMiniProgramDownloadUrl(list, 'video');
  return '/' + downloadLink;
};

export const DownloadSingleVideo = (props: any) => {
  const { children, url } = props;
  const linkPath = getDownloadVideoLink(url);
  return (
    <wx-open-launch-weapp
      id="launch-btn"
      username="gh_e97c78460d68"
      path={linkPath}
      style={Object.assign({ flex: 1 })}
    >
      <script type="text/wxtag-template">
        {/*注意，需要最小宽度，否则容易出现字换行的情况， white-space:nowrap也无法解决*/}
        <div
          style={{
            textAlign: 'center',
            width: 36,
            height: 36,
          }}
        >
          {children}
        </div>
      </script>
    </wx-open-launch-weapp>
  );
};

const DownloadIcon = () => {
  return (
    <img
      src="https://resources.jimage.cn/80667/102616/qu5tolrias8.png"
      alt="download"
      style={{
        width: 36,
        height: 36,
        transform: 'scale(0.56)',
      }}
    />
  );
};

export const DownloadAction = inject('rootStore')(
  observer((props: any) => {
    const { item = {}, download } = props;
    if (!download) {
      return null;
    }

    const fileUrl = item.path.split('?')[0];
    const httpsUrl = getRealUrl(fileUrl);

    if (isWeixinMobile()) {
      return (
        <DownloadSingleVideo url={httpsUrl}>
          <DownloadIcon />
        </DownloadSingleVideo>
      );
    }
    return (
      <PlatformAuthClickActionWrap
        pcAction={() => {
          const name = getFileNameByArbitraryUrl(fileUrl);
          const a = document.createElement('a');
          a.href = httpsUrl;
          a.download = name;
          a.click();
        }}
      >
        <DownloadIcon />
      </PlatformAuthClickActionWrap>
    );
  })
);

/**
 * 增加视频说明的显示，最多显示三行，超过则需点击显示全部（忘记示意图里添加显示全部按钮了）
 * text: string,
 * max: 3
 * @param props
 * @constructor
 */
export const Ellipsis = (props: { text: string; max?: number }) => {
  const { text, max = 3 } = props;
  const [showAll, setShowAll] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (textRef.current) {
      // 检查是否存在文本溢出
      const { scrollHeight, offsetHeight } = textRef.current;
      setIsOverflow(scrollHeight > offsetHeight);
    }
  }, [text]);

  return (
    <div
      onClick={() => {
        if (!isOverflow) {
          return;
        }
        setShowAll(!showAll);
      }}
    >
      <div
        ref={textRef}
        style={{
          maxHeight: showAll ? 'none' : `${max * 1.5}em`, // 假设每行高度为 1.5em
          overflow: 'hidden',
          lineHeight: '1.5em',
          WebkitLineClamp: showAll ? 'unset' : max, // 用于支持多行截断的 CSS 属性
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
        }}
      >
        {text}
      </div>
      {isOverflow && (
        <button
          onClick={() => setShowAll(!showAll)}
          style={{
            marginTop: '0.5em',
            color: '#007bff',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          {showAll ? intl.get('Fold') : intl.get('Expand')}
        </button>
      )}
    </div>
  );
};

export const VideoItem = (props: any) => {
  const { video, onClick = R.T, download = false, width } = props;
  const path = R.pathOr('', ['path'], video);
  const coverUrl = R.pathOr('', ['options', 'coverUrl'], video);

  //  video.FileInfoList[0].FileBasicInfo.Duration
  const duration =
    //  @ts-ignore
    R.pathOr('0', ['FileInfoList', 0, 'FileBasicInfo', 'Duration'], video) * 1;

  return (
    <div
      className="video-item"
      onClick={onClick}
      style={{
        width: width,
      }}
    >
      <div className="video-item-thumb">
        <img
          className="video-item-img-container"
          src={coverUrl ? coverUrl : path}
          alt={video.desc}
        />
        <div className="video-item-ico-play">
          <ReactSVG src={require('../../svg/play.svg')} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width,
            alignItems: 'center',
            padding: '0px 8px',
          }}
        >
          <div
            style={{
              display: download ? 'flex' : 'none',
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            className="download-from-list"
          >
            <DownloadAction {...props} item={video} />
          </div>
          <div className="item-duration">{humanizeDuration(duration)}</div>
        </div>
      </div>
      <div className="video-item-info">
        <div className="video-item-title">
          {R.pipe(R.propOr('', 'name'), R.replace(/\.\w+$/, ''))(video)}
        </div>
      </div>
    </div>
  );
};

export const VideoListWrap = (props: MultiVideoProps) => {
  const { search, download } = props;
  const [name, setName] = useState('');
  const { currentVideos, loadMoreVideos, resetList } = useV2Video({
    ...props,
    name,
  });
  // const { h1Color, h2Color, mainColor } = useTheme();
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  const onSearch = (val: string) => {
    setName(val);
    resetList();
  };

  const handleActive = useCallback(
    (index: number) => {
      return new Promise((resolve) => {
        const video = currentVideos[index];
        resolve({
          ...video,
          videoUrl: video.path.split('?')[0],
        });
      });
    },
    [currentVideos]
  );
  const ref = useRef<HTMLDivElement>(null);

  const maxShowWidthOfWindow =
    document.querySelector('.main-page')?.clientWidth || 0;

  return (
    <div className="bigvideo-wrapper">
      <div className={classNames('vote search-bar', { hidden: !search })}>
        <SearchBar
          placeholder="请输入视频标题"
          style={{
            fontSize: '12px',
          }}
          onSearch={onSearch}
          onClear={() => {
            onSearch('');
          }}
        />
      </div>
      <ListWrapper
        onRefresh={() => Promise.resolve(currentVideos)}
        onLoadMore={loadMoreVideos}
        isContainer={true}
        scrollerChildrenSelector={'.gallery-home'}
        eventName={'gallery-list'}
      >
        <DetectWindowWidth>
          {({ width: windowWidth }: any) => {
            return (
              <div className="video-list-wrap" ref={ref}>
                <Masonry columnsCount={2}>
                  {currentVideos.map((video, index) => (
                    <VideoItem
                      width={
                        (windowWidth -
                          (maxShowWidthOfWindow - windowWidth) / 3) /
                        2
                      }
                      {...props}
                      key={JSON.stringify(video)}
                      video={video}
                      onClick={() => setCurrentIndex(index)}
                    />
                  ))}
                </Masonry>
              </div>
            );
          }}
        </DetectWindowWidth>
      </ListWrapper>
      {currentIndex !== null && (
        <VerticalSwiper
          list={currentVideos}
          current={currentIndex}
          onClose={() => setCurrentIndex(null)}
          placeholder={(item) => {
            return (
              <div
                style={{
                  width: '100vw',
                  height: '100vh',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={item.path}
                  alt={item.desc}
                  style={{ width: '100%', height: 'auto' }}
                />
              </div>
            );
          }}
          onActive={handleActive}
          onSuccessRender={(item) => (
            <div style={{ position: 'relative' }}>
              <VePlayer url={item.path.split('?')[0]} poster={item.path} />
              <div className="video-info">
                <div className="video-info-title">
                  <div className="video-info-title-name">
                    {
                      //  去掉 .mp4 等后缀
                      R.pipe(
                        R.propOr('', 'name'),
                        R.replace(/\.\w+$/, '')
                      )(item)
                    }
                  </div>
                  {download ? (
                    <DownloadAction item={item} download={download} />
                  ) : null}
                </div>
                {item.desc && (
                  <div className="desc">
                    <Ellipsis text={R.pathOr('', ['desc'], item)} />
                  </div>
                )}
              </div>
            </div>
          )}
          onFailRender={(res) => <div style={{ color: 'red' }}>error{res}</div>}
        />
      )}
    </div>
  );
};
